var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 6,
    fill: "url(#paint0_radial_452_738)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4666 20.0001L18.4832 24.0335L26.5332 15.9668",
    stroke: "#01C37D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4166 4.0832C19.5666 3.09987 21.4499 3.09987 22.6166 4.0832L25.2499 6.34987C25.7499 6.7832 26.6832 7.1332 27.3499 7.1332H30.1832C31.9499 7.1332 33.3999 8.5832 33.3999 10.3499V13.1832C33.3999 13.8332 33.7499 14.7832 34.1832 15.2832L36.4499 17.9165C37.4332 19.0665 37.4332 20.9499 36.4499 22.1165L34.1832 24.7499C33.7499 25.2499 33.3999 26.1832 33.3999 26.8499V29.6832C33.3999 31.4499 31.9499 32.8999 30.1832 32.8999H27.3499C26.6999 32.8999 25.7499 33.2499 25.2499 33.6832L22.6166 35.9499C21.4666 36.9332 19.5832 36.9332 18.4166 35.9499L15.7832 33.6832C15.2832 33.2499 14.3499 32.8999 13.6832 32.8999H10.7999C9.03322 32.8999 7.58322 31.4499 7.58322 29.6832V26.8332C7.58322 26.1832 7.23322 25.2499 6.81655 24.7499L4.56655 22.0999C3.59989 20.9499 3.59989 19.0832 4.56655 17.9332L6.81655 15.2832C7.23322 14.7832 7.58322 13.8499 7.58322 13.1999V10.3332C7.58322 8.56654 9.03322 7.11654 10.7999 7.11654H13.6832C14.3332 7.11654 15.2832 6.76654 15.7832 6.3332L18.4166 4.0832Z",
    stroke: "#01C37D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_452_738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5 20) rotate(90) scale(20)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5FFF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.306cf2a40f2e90a54b4278d17abf351e.svg";
export { ForwardRef as ReactComponent };